export function dateRange(start, end, current) {
  if (!start && !end) return "";
  return `${start || ""} - ${current ? "Present" : (end || "")}`;
}

export function initials(name) {
  return (name || "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";
}
